var activeTab = 1;
var activeTab2 = 1;

$( "#tp1-tab-link" ).click(function() {
    activeTab = 1;

    $( "#tp1-tab-link").addClass("active");
    $( "#tp2-tab-link").removeClass("active");
});

$( "#tp2-tab-link").click(function() {
    activeTab = 2;
    $( "#tp2-tab-link").addClass("active");
    $( "#tp1-tab-link").removeClass("active");
});



$( ".tp1-tab-link2").click(function() {
    activeTab2 = 1;
    $( ".tp1-tab-link2" ).addClass("active");
    $( ".tp2-tab-link2" ).removeClass("active");
});

$( ".tp2-tab-link2").click(function() {
    activeTab2 = 2;

    $( ".tp2-tab-link2" ).addClass("active");
    $( ".tp1-tab-link2" ).removeClass("active");
});

